"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const react_focus_lock_1 = require("react-focus-lock");
const LanguageComponent_1 = require("./Language/LanguageComponent");
const CountryComponent_1 = require("./Country/CountryComponent");
const LanguageLink_1 = require("./Language/LanguageLink");
const chooseLocationContext_1 = require("./chooseLocationContext");
const ChooseLocationPopup = ({ countries }) => {
    const { state, dispatch } = (0, chooseLocationContext_1.useChooseLocationContext)();
    const { dictionary, currentCountry, selectedCountry, isLanguageMenuOpened, isLanguageButtonOpened, searchTerm, } = state;
    const popupContentRef = React.useRef(null);
    React.useEffect(() => {
        if (!countries.length) {
            return;
        }
        if (selectedCountry.isMultiLanguage &&
            selectedCountry.countryName == currentCountry.countryName) {
            dispatch({
                type: chooseLocationContext_1.ChooseLocatioActionType.SHOW_LANGUAGE_MENU_WITH_CURRENT_LANGUAGE,
            });
        }
        else {
            dispatch({
                type: chooseLocationContext_1.ChooseLocatioActionType.SET_FIRST_LANGUAGE_URL_SELECTED,
            });
        }
    }, [
        countries.length,
        currentCountry,
        selectedCountry,
        selectedCountry.countryName,
        selectedCountry.isMultiLanguage,
        dispatch,
    ]);
    React.useEffect(() => {
        dispatch({
            type: chooseLocationContext_1.ChooseLocatioActionType.COUNTRIES_NOT_FOUND,
        });
        const filteredCountries = countries.filter(country => country.countryName.toLowerCase().includes(searchTerm.toLowerCase()));
        if (filteredCountries.length <= 0) {
            dispatch({
                type: chooseLocationContext_1.ChooseLocatioActionType.COUNTRIES_FOUND,
            });
        }
        else {
            dispatch({
                type: chooseLocationContext_1.ChooseLocatioActionType.SET_COUNTRIES,
                payload: filteredCountries,
            });
        }
    }, [countries, searchTerm, dispatch]);
    return ((0, jsx_runtime_1.jsx)(react_focus_lock_1.default, { children: (0, jsx_runtime_1.jsx)("div", { className: "bg-surface-primary z-navigation px-2xl py-sm md:py-2xl xs:top-[80px] md:top-[39px]  md:border-secondary md:rounded-context-menu-border-radius fixed left-0 top-[64px] h-full w-full min-w-[320px] md:absolute  md:left-[-80px] md:h-auto md:w-[320px] md:min-w-[200px] md:border", "aria-modal": "true", "aria-labelledby": "language-picker-header", "aria-describedby": "language-picker-desc", id: "language-picker-dropdown", tabIndex: -1, "data-no-focus-lock": true, children: (0, jsx_runtime_1.jsx)("div", { className: "space-y-md flex min-h-0 w-full flex-col", ref: popupContentRef, children: countries.length ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h2", { id: "language-picker-header", className: "subtitle-lg-moderate", children: dictionary.locationTitle }), (0, jsx_runtime_1.jsx)("p", { id: "language-picker-desc", className: "body-sm text-secondary", children: dictionary.locationDescription }), (0, jsx_runtime_1.jsx)("form", { className: "flex min-h-0 flex-col", id: "language-search-form", role: "search", onSubmit: event => event.preventDefault(), children: (0, jsx_runtime_1.jsx)(CountryComponent_1.default, {}) }), isLanguageMenuOpened && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "border-secondary my-2xs w-full border-b", "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)(LanguageComponent_1.default, {}), (0, jsx_runtime_1.jsx)("div", { className: "border-secondary my-2xs w-full border-b", "aria-hidden": "true" })] })), isLanguageButtonOpened && (0, jsx_runtime_1.jsx)(LanguageLink_1.default, {})] })) : ((0, jsx_runtime_1.jsx)("h2", { className: "header-locations__error body-md text-center mb-0 text-primary", children: dictionary.communicationErrorMessage })) }) }) }));
};
exports.default = ChooseLocationPopup;
